import "./LyneContextHelp.scss";

import { SbbMiniButton } from "@sbb-esta/lyne-react/button";
import { SbbPopover } from "@sbb-esta/lyne-react/popover";
import { DisplayTextWrapped } from "components/DisplayFields/DisplayTextWrapped";
import { generateGuid } from "helpers";
import { useTranslations } from "providers";
import React, { useMemo } from "react";

interface LyneContextHelpProps {
  name?: string;
  title: string;
  content: string;
  hideLabel?: boolean;
}

export const LyneContextHelp: React.FC<LyneContextHelpProps> = (props) => {
  const i18n = useTranslations();
  let { name, title, content, hideLabel = true } = props;
  const nameToUse = useMemo(() => name || generateGuid(), [name]);

  let titleToUse = `${title || ""}`.trim();
  if (!titleToUse) titleToUse = `${name || ""}`.trim() || i18n.Help;

  content = `${content || ""}`.trim();
  if (!content) {
    content = i18n.ContextHelp_Fallback_Content.replace("{0}", `${name || titleToUse}`);
  }

  const POPUP_WRAP = 60;

  return (
    <span id={nameToUse} className="lyne-context-help" slot="suffix">
      <SbbMiniButton iconName="circle-question-mark-small" />
      <span style={{ colorScheme: "dark" }}>
        <SbbPopover trigger={nameToUse} className="small" hoverTrigger>
          <div style={{ color: "#fff" }}>
            <DisplayTextWrapped text={titleToUse} maxChars={POPUP_WRAP} as="b" />
            <DisplayTextWrapped text={content} maxChars={POPUP_WRAP} as="p" />
          </div>
        </SbbPopover>
      </span>
      {!hideLabel && <span className="label">{i18n.ContextHelp}</span>}
    </span>
  );
};
